export default {
    time: {
        openingHoursTitle: "Öffnungszeiten",
        at: "um",
        to: "bis",
        opensToday: "Öffnet heute",
        opens: "Öffnet",
        open24_7: "24/7 geöffnet",
        closed: "Geschlossen",
        openUntil: "Heute bis",
        daily: "Täglich von",
        month: [
            'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
            'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
        ],
        monthAbbr: [
            'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
            'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'
        ],
        dayOfWeek: [
            'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag', 
        ],
        dayOfWeekAbbr: [
            'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So', 
        ],
        temporarilyClosed: "Vorübergehend geschlossen",
        opened: "geöffnet",
        today: "geöffnet"
    },
    search: {
        placeholder: "Straße, Stadt oder PLZ",
        submitLabel: "Suchen",
        clearLabel: "Suche löschen",
        yourLocation: "Dein Standort",
    },
    filtering: {
        servicesTitle: "Dienstleistungen",
        services: {
            WF: 'WLAN-Hotspot',
            CD: 'Mobile Zahlung',
            DT: 'Drive-Thru',
            DR: 'Digitale Belohnungen',
            hrs24: '24 Stunden am Tag geöffnet',
            WA: 'Ofenwarme Speisen',
            LB: 'LaBoulange',
            XO: 'Mobile Bestellung und Bezahlung',
            VS: 'Verismo',
            NB: 'Nitro Cold Brew',
            CL: 'Starbucks Reserve-Clover Brewed',
        }
    },
    stores: {
        cta: {
            call: "Anrufen",
            directions: "Wegbeschreibung",
            website: "Webseite",
            'club details': 'Studiodetails',
            'view tariffs': 'Anmelden',
            'View Map': "Karte anzeigen",
            'View List': "Liste anzeigen"
        },
        messages: {
            initialHeader: "Suche nach Straße, Stadt oder PLZ, um nahegelegene Studios anzuzeigen",
            emptyHeader: "Kein Studio gefunden",
            initialBody: "oder klicke auf die Karte, um ein Studio auszuwählen",
            emptyBody: "Bitte suche nach einem anderen Standort oder hebe deine Filterauswahl auf"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Autobahnen',
            tolls: 'Mautgebühren',
            ferries: 'Fähren'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'Meilen'
        },
        options: "Route Optionen",
        avoid: "Vermeiden",
        units: "Entfernungseinheiten",
        messages: {
            initialBody: "Gebe einen Startpunkt und ein Ziel ein, um verfügbare Routen und die Reisezeit anzuzeigen.",
            error: "Entschuldigung, wir konnten keine Fahrtrichtungen berechnen",
            from: "von",
            to: "nach",
            forTravelMode: "für den Reisemodus",
            via: "über",
            details: "Details",
            withoutTraffic: "ohne Verkehr",
            openGoogleMaps: "in Google Maps öffnen"
        }
    },
    errors: {
        loadingLibrary: "Fehler beim Laden des {library} Skripts",
        geolocationFailed: "Benutzerlokalisierung fehlgeschlagen",
        apiErrors: {
            "401": "Nicht autorisiert",
            "403": "Verboten",
            "429": "Zu viele Anfragen",
            "500": "Interner Serverfehler",
            other: "Ein unerwarteter Serverfehler ist aufgetreten"
        }
    },
};
